import { render, staticRenderFns } from "./StepsList.vue?vue&type=template&id=6cf8b8c2&scoped=true"
import script from "./StepsList.vue?vue&type=script&lang=js"
export * from "./StepsList.vue?vue&type=script&lang=js"
import style0 from "./StepsList.vue?vue&type=style&index=0&id=6cf8b8c2&prod&lang=less&scoped=true"
import style1 from "./StepsList.vue?vue&type=style&index=1&id=6cf8b8c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8b8c2",
  null
  
)

export default component.exports